import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=b4ac1a36"
var script = {}
import style0 from "./loader.component.vue?vue&type=style&index=0&id=b4ac1a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports